import React from 'react';

const IconDiscountPercent = () => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.3295 17.5918C18.3693 17.5918 17.5879 18.373 17.5879 19.3332C17.5879 20.2937 18.3693 21.0751 19.3295 21.0751C20.29 21.0751 21.0709 20.2937 21.0709 19.3332C21.0707 18.373 20.2898 17.5918 19.3295 17.5918Z'
        fill='#2F3D48'
      />
      <path
        d='M10.6491 8.91309C9.68863 8.91309 8.90723 9.69449 8.90723 10.655C8.90746 11.615 9.68887 12.3961 10.6491 12.3961C11.6093 12.3961 12.3903 11.615 12.3903 10.655C12.3903 9.69449 11.6093 8.91309 10.6491 8.91309Z'
        fill='#2F3D48'
      />
      <path
        d='M15 0C6.72867 0 0 6.72867 0 15C0 23.2709 6.72867 30 15 30C23.2704 30 29.9986 23.2709 29.9986 15C29.9986 6.72867 23.2704 0 15 0ZM10.6498 7.03664C12.6443 7.03664 14.2676 8.65945 14.2676 10.6549C14.2676 12.6495 12.6443 14.2727 10.6498 14.2727C8.65453 14.2727 7.03148 12.6495 7.03148 10.6549C7.03148 8.65945 8.65477 7.03664 10.6498 7.03664ZM9.54984 21.7763C9.36703 21.9595 9.12633 22.0514 8.88656 22.0514C8.64656 22.0514 8.40633 21.9595 8.22305 21.7763C7.85672 21.4099 7.85672 20.8155 8.22305 20.4497L20.4487 8.22352C20.8148 7.85719 21.409 7.85719 21.7755 8.22352C22.1419 8.58984 22.1419 9.18422 21.7755 9.55031L9.54984 21.7763ZM19.3296 22.9519C17.3346 22.9519 15.7113 21.3288 15.7113 19.3336C15.7113 17.3391 17.3346 15.7158 19.3296 15.7158C21.3244 15.7158 22.9474 17.3391 22.9474 19.3336C22.9472 21.3288 21.3241 22.9519 19.3296 22.9519Z'
        fill='#2F3D48'
      />
      <path
        d='M15 0C6.72867 0 0 6.72867 0 15C0 23.2709 6.72867 30 15 30C23.2704 30 29.9986 23.2709 29.9986 15C29.9986 6.72867 23.2704 0 15 0ZM10.6498 7.03664C12.6443 7.03664 14.2676 8.65945 14.2676 10.6549C14.2676 12.6495 12.6443 14.2727 10.6498 14.2727C8.65453 14.2727 7.03148 12.6495 7.03148 10.6549C7.03148 8.65945 8.65477 7.03664 10.6498 7.03664ZM9.54984 21.7763C9.36703 21.9595 9.12633 22.0514 8.88656 22.0514C8.64656 22.0514 8.40633 21.9595 8.22305 21.7763C7.85672 21.4099 7.85672 20.8155 8.22305 20.4497L20.4487 8.22352C20.8148 7.85719 21.409 7.85719 21.7755 8.22352C22.1419 8.58984 22.1419 9.18422 21.7755 9.55031L9.54984 21.7763ZM19.3296 22.9519C17.3346 22.9519 15.7113 21.3288 15.7113 19.3336C15.7113 17.3391 17.3346 15.7158 19.3296 15.7158C21.3244 15.7158 22.9474 17.3391 22.9474 19.3336C22.9472 21.3288 21.3241 22.9519 19.3296 22.9519Z'
        fill='#2F3D48'
      />
    </svg>
  );
};

export default IconDiscountPercent;
